import React from 'react';
import Skeleton from 'components/LoadingSkeleton';

const StatsSkeleton = () => {
  return (
    <div className="space-y-6">
      <h5 className="typography-product-heading-compact-desktop max-sm:typography-product-subheading mb-ds-xl max-sm:mb-ds-md">
        Dashboard
      </h5>
      <div className="grid grid-cols-1 gap-6 md:grid-cols-3">
        {[...Array(3)].map((_, i) => (
          <div
            key={i}
            className="border-color-border-lightmode-primary dark:border-color-border-darkmode-primary rounded-lg border bg-color-bg-lightmode-primary p-6 dark:bg-color-bg-darkmode-primary"
          >
            <Skeleton />
          </div>
        ))}
      </div>
    </div>
  );
};

export default StatsSkeleton;
